import styled from 'styled-components';
import { sizes, theme } from 'theme';

export const ExpandableContentButtonFullwidth = styled.button`
    display: flex;
    flex-direction: column;
    padding: ${sizes.spacingMd};
    border: 2px solid ${theme.secondaryButtonHoverBackgroundColour};
    border-radius: 24px;
    background-color: inherit;
    cursor: pointer;
    &:hover {
        background-color: ${theme.secondaryButtonHoverBackgroundColour};
    }
    &:focus {
        background-color: ${theme.buttonFocusBackgroundColour};
        border: 2px solid ${theme.primaryButtonBorderColour};
        outline: ${theme.primaryButtonBorderColour};
        color: ${theme.buttonFocusTextColour};
    }
`;
